import {BroadcastEventBus} from './broadcast/broadcast-event-bus';
import {BroadcastEventSymbol} from './common/symbols';
import {Constructor} from './common/types';
import {EventBus} from './local/events';

export function dispatchAppEvent<T>(event: Constructor<T>, args?: T): void {
	EventBus.dispatch(event, args);

	if(event?.prototype && event?.prototype[BroadcastEventSymbol]) {
		BroadcastEventBus.dispatch(event, args);
	}
}
